import { createStore } from 'vuex'
import VuexPersistence from 'vuex-persist'
import common from './common'

import baseStates from './baseStates'

import timesheet from '../components/Sheets/Timesheet/state'
import sheet from '../components/Sheets/Sheet/state'
import notification from '../components/MainHeader/state'
import dashboards from '../components/DashBoards/state'
import verifyTimesheet from '../components/Sheets/VerifyTimesheet/state'
import whb from '../components/Whb/state'
import workSchedule from 'src/components/WorkSchedule/state'
import employee from 'src/components/Employee/state'
import approvalsRules from 'src/components/ApprovalsRules/state'
import gestaoDeSolicitacoes from 'src/components/Approvals/state'
import gestaoDeFerias from 'src/typescript/modulos/calendario-de-trabalho/GerenciamentoDeFerias/apresentacao/state'
import regrasDeFerias from 'src/typescript/modulos/calendario-de-trabalho/RegrasDeFerias/state'
import lockerRules from 'src/components/LockerRules/state'
import company from 'src/components/Company/state'
import locker from 'src/components/Locker/state'
import timeoff from 'src/components/HourBankRules/state'
import faceBiometric from 'src/components/FaceBiometric/state'
import biometria from 'src/typescript/modulos/estrutura-de-pontos-da-empresa/biometria/apresentacao/biometria.store'
import permissions from 'src/components/Permissions/state'
import regrasDeNotificacao from 'src/typescript/modulos/acompanhamento/RegraDeNotificacao/apresentacao/state'
import customizacaoDeCalculo from 'src/components/CustomizacoesDeCalculo/index'
import home from 'src/components/Home/state'
import parametrizadorE02 from 'src/components/ParametrizadorE02/index'
import acompanhamentoEmTempoReal from 'src/components/AcompanhamentoTempoReal/state'
import painelSolicitacaoDeHorasExtras from 'src/typescript/modulos/acompanhamento/PainelSolicitacoesDeHorasExtras/dominio/state'
import layoutE02 from 'src/typescript/modulos/calculos-do-sistema/e02/state'
import modulosEFuncionalidades from 'src/store/core/modulos_funcionalidades'
import assistentePontotel from 'src/typescript/modulos/governanca/AssistentePontotel/apresentacao/state'
import { pluginDeLogDoAssistente } from 'src/typescript/modulos/governanca/AssistentePontotel/apresentacao/pluginDeLogDoAssistente'

const persistor = new VuexPersistence({
  key: 'vuex',
  modules: ['auth', 'visualConfigs', 'perfilDeAcessoSelecionadoParaMultiPerfis', 'biometria']
})

const MODULES_PER_NAME = {
  timesheet: timesheet
}

function normalizeModulePath (modulePath) {
  return Array.isArray(modulePath) ? modulePath : [modulePath]
}

function getModuleDefinition (modulePath) {
  const normalizedModulePath = normalizeModulePath(modulePath)
  const moduleName = normalizedModulePath.join('/')

  if (!MODULES_PER_NAME[moduleName]) {
    throw new Error(`Module "${moduleName}" is not mapped in MODULES_PER_NAME`)
  }

  return MODULES_PER_NAME[moduleName]
}

const store = createStore({
  state: {
    auth: {
      authorization: null,
      accessToken: null,
      refreshToken: null, // it wil only exists if theres login with saml, amplify handles it in normal logins
      userPoolId: null,
      userPoolWebClientId: null,
      tokenAPI: null,
      dataCriacaoToken: null,
      // salvamos a url da api de renovacao do token do keycloak no login para utilizá-la no Worker de refresh token
      renovacaoTokenKeycloakAPI: null,
      // salvamos a url da api de logout do keycloak no login para utilizá-la no logout
      logoutKeycloakAPI: null,
      realmKeycloak: null,
    },
    backNotification: null,
    userInfo: null,
    visualConfigs: null,
    CategoriaBarradeNavegacao: null,
    perfilDeAcessoSelecionadoParaMultiPerfis: 'gestor',
    possuiTour: null,
    usuarioUserFlowPendente: null
  },
  ...baseStates,
  modules: {
    common,
    timesheet,
    sheet,
    dashboards,
    notification,
    verifyTimesheet,
    whb,
    workSchedule,
    employee,
    approvalsRules,
    lockerRules,
    company,
    locker,
    timeoff,
    faceBiometric,
    biometria,
    permissions,
    regrasDeNotificacao,
    home,
    ...customizacaoDeCalculo.vuex,
    gestaoDeSolicitacoes,
    gestaoDeFerias,
    regrasDeFerias,
    ...parametrizadorE02.vuex,
    acompanhamentoEmTempoReal,
    modulosEFuncionalidades,
    painelSolicitacaoDeHorasExtras,
    layoutE02,
    assistentePontotel
  },
  plugins: [
    persistor.plugin,
    pluginDeLogDoAssistente
  ]
})

export async function requestModuleUse (modulePath) {
  const normalizedModulePath = normalizeModulePath(modulePath)

  if (!store.hasModule(normalizedModulePath)) {
    await store.registerModule(normalizedModulePath, getModuleDefinition(normalizedModulePath))
  }
}

window.vuex = store

export default store
